<template>
  <BModal
    id="modal-link-account"
    centered
    no-close-on-backdrop
    hide-footer
    hide-header
    size="md"
    @hidden="resetForm"
  >
    <div class="py-2 px-1">
      <!-- Header -->
      <div class="flex items-center justify-between mb-1">
        <h5 class="text-black text-[20px] font-semibold mb-0">
          Hubungkan Akun
        </h5>
        <button
          class="btn p-0"
          @click="$bvModal.hide('modal-link-account')"
        >
          <feather-icon
            icon="XIcon"
            size="20"
            class="text-[#6B7280]"
          />
        </button>
      </div>

      <!-- Subtitle -->
      <p class="text-[#6B7280] text-[14px] mb-1">
        Tautkan akun partner untuk mengelompokkan partner sesuai dengan benefit yang dia dapatkan
      </p>

      <!-- Tautkan Email Partner -->
      <div class="mb-2">
        <EmailPartnerSelect
          ref="emailPartnerSelect"
          v-model="selectedEmails"
        />
      </div>

      <!-- Footer Buttons -->
      <div class="flex items-center justify-end gap-2 pt-2">
        <b-button
          variant="outline-secondary"
          class="!rounded-lg !px-6 !py-2 !border-[#E5E5E5] !text-black"
          @click="$bvModal.hide('modal-link-account')"
        >
          Batal
        </b-button>
        <b-button
          :variant="isFormValid ? 'primary' : 'secondary'"
          :disabled="!isFormValid || isSubmitting"
          class="!rounded-lg !px-6 !py-2"
          :class="{ '!bg-[#F95031] !border-[#F95031]': isFormValid }"
          @click="handleSubmit"
        >
          <b-spinner
            v-if="isSubmitting"
            small
            class="mr-1"
          />
          Simpan
        </b-button>
      </div>
    </div>
  </BModal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import EmailPartnerSelect from './EmailPartnerSelect.vue'

export default {
  components: {
    EmailPartnerSelect,
  },
  data() {
    return {
      selectedEmails: [],
      isSubmitting: false,
    }
  },
  computed: {
    isFormValid() {
      return this.selectedEmails.length > 0
    },
  },
  methods: {
    resetForm() {
      this.selectedEmails = []
      this.isSubmitting = false
      if (this.$refs.emailPartnerSelect) {
        this.$refs.emailPartnerSelect.reset()
      }
    },
    handleSubmit() {
      if (!this.isFormValid) return
      const url = '/auth/api/v1/organizations/link-account'
      const selectedPartner = this.$refs.emailPartnerSelect
        ? this.$refs.emailPartnerSelect.selectedPartner
        : 'komerce'
      const params = {
        id_org: parseInt(this.$route.params.id, 10),
      }

      const userIds = []
      const externalUsers = []

      this.selectedEmails.forEach(e => {
        const product = e.product || selectedPartner
        if (product === 'komerce') {
          if (e.user_id) userIds.push(e.user_id)
        } else {
          externalUsers.push({
            email: e.email || '',
            external_id: String(e.external_id || e.user_id || e.id || ''),
            product,
          })
        }
      })

      if (userIds.length > 0) params.user_ids = userIds
      if (externalUsers.length > 0) params.external_users = externalUsers

      this.isSubmitting = true
      newAxiosIns
        .post(url, params)
        .then(() => {
          this.$toast_success({ message: 'Berhasil menambahkan user' })
          this.$emit('submit')
          this.$bvModal.hide('modal-link-account')
        })
        .catch(err => {
          const message = err?.response?.data?.meta?.message
          if (message) {
            const capitalize = message.charAt(0).toUpperCase() + message.slice(1)
            this.$toast_error({ message: capitalize })
          } else if (err?.message) {
            this.$toast_error({ message: err.message })
          }
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
  },
}
</script>
